import React, { useEffect } from "react";
import generatorForm from "../../generator-form";
import { FormItemFormat } from "../../../../components/form-item/form-item-format/form-item-format";
import { useFormikContext } from "formik";
import { getPrograms } from "../../generator-utils";
export var FormatForm = function (tooltips) {
    var formatField = generatorForm.format;
    var _a = useFormikContext().values, stepActive = _a.stepActive, program = _a.program, format = _a.format, projects = _a.projects;
    var _b = useFormikContext(), isSubmitting = _b.isSubmitting, submitForm = _b.submitForm, setFieldValue = _b.setFieldValue;
    var selectedProgram = getPrograms().find(function (_a) {
        var value = _a.value;
        return value === program;
    });
    useEffect(function () {
        if (stepActive) {
            setTimeout(function () {
                var elem = document.getElementsByClassName('scroll_to_error').item(0);
                if (elem !== null && elem !== undefined) {
                    elem.classList.remove("shake-error");
                    elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                    elem.classList.add("shake-error");
                    setFieldValue("stepActive", false);
                }
            }, 150);
        }
    });
    return (React.createElement(React.Fragment, null, selectedProgram && (React.createElement("div", { className: "format-form" },
        React.createElement("div", { className: "format-form__container" },
            React.createElement("div", { className: "format-form__note" },
                React.createElement("div", { className: "title-label" },
                    selectedProgram.name,
                    selectedProgram.note ? (selectedProgram.separator ? (React.createElement(React.Fragment, null,
                        selectedProgram.separator,
                        " ",
                        selectedProgram.note)) : (React.createElement(React.Fragment, null,
                        " - ",
                        selectedProgram.note))) : (React.createElement(React.Fragment, null)))),
            React.createElement("div", { className: "format-form__form" },
                React.createElement(FormItemFormat, { name: formatField.name, options: selectedProgram.formatGroups, tooltips: tooltips, program: selectedProgram.value, onChange: function (format) {
                        var selectedFormatGroup = selectedProgram === null || selectedProgram === void 0 ? void 0 : selectedProgram.formatGroups.find(function (_a) {
                            var formats = _a.formats;
                            return formats.find(function (_a) {
                                var formatTypes = _a.formatTypes;
                                return formatTypes.find(function (_a) {
                                    var value = _a.value;
                                    return value === format;
                                });
                            });
                        });
                        var selectedFormat = selectedFormatGroup === null || selectedFormatGroup === void 0 ? void 0 : selectedFormatGroup.formats.find(function (_a) {
                            var formatTypes = _a.formatTypes;
                            return formatTypes.find(function (_a) {
                                var value = _a.value;
                                return value === format;
                            });
                        });
                        var selectedFormatType = selectedFormat === null || selectedFormat === void 0 ? void 0 : selectedFormat.formatTypes.find(function (_a) {
                            var value = _a.value;
                            return value === format;
                        });
                        setFieldValue("projects", projects.slice(0, selectedFormatType === null || selectedFormatType === void 0 ? void 0 : selectedFormatType.maxProjectCount));
                        submitForm();
                    } })))))));
};
